export default {"src":"/_next/static/media/search-book.31c46055.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};